
/**
 * 定義基礎頁面載入需要的方法、屬性
 *
 * @export
 * @class BasePageLoader
 */
export default class BasePageLoader {
    preloader = null;
    currentComposition = "";

    uniqueTags = ["clipPath"];

    textTags = ["justify"];

    /**
     *
     * @type {Function}
     * @memberof BasePageLoader
     */
    renderBook = function() {
        
    };

    /**
     *
     * @type {Function}
     * @memberof BasePageLoader
     */
    pageStageInitCallback = null;
    /**
     * 載入animate頁面失敗
     *
     * @memberof BasePageLoader
     */
    onLoadPageError() {
    }

    /**
     * pageStage設置完成, 只會執行一次
     *
     * @memberof BasePageLoader
     */
    onPageStageInit() {
        if (typeof this.pageStageInitCallback == "function") {
            this.pageStageInitCallback();
            this.pageStageInitCallback = null;
        }
    }
    /**
     * 
     */
    updateCanvasScale() {
    }

    /**
     * 
     * @param {HTMLCollectionOf<SVGImageElement>} nodes 
     */
    overrideImgResource(nodes) {
        for (let i = 0; i < nodes.length; i++) {
            const newImgSrc = BookData.Instance.getAFilePath() + nodes.item(i).getAttribute("xlink:href");
            // imgs.item(0).setAttribute("xlink:href", newImgSrc)
            nodes.item(i).setAttribute("xlink:href", newImgSrc);
        }
    }
    /**
     * override defs id
     * @param {Element} child 
     * @param {Document} doc 
     */
    overrideUse(child, doc) {
        const newId = child.id + "_" + new Date().getTime().toString();
        const useList = doc.getElementsByTagName('use');

        for (let i = 0; i < useList.length; i++) {
            if (useList.item(i).getAttribute("xlink:href") == ("#" + child.id)) {
                useList.item(i).setAttribute("xlink:href", "#" + newId);
            }
        }
        child.id = newId;
    }
    /**
     * override id of tag to origin id plus timestamp
     * @param {Array<string>} tags 
     * @param {Document} doc 
     */
    overrideTagsId(tags, doc) {
        for(let i = 0; i < tags.length; i++) {
            const list = doc.getElementsByTagName(tags[i]);
            for(let j = 0; j < list.length; j++) {
                list.item(j).id = list.item(j).id + "_" + new Date().getTime().toString();
            }
        }
    }

    modifyText(doc) {
        const groups = doc.getElementsByTagName("g");

            const adjustTexts = [];
            const adjustValue = []

            for (let i = 0; i < groups.length; i++) {
                for (let j = 0; j < this.textTags.length; j++) {
                    if (groups[i].id.includes(this.textTags[j])) {
                        const value = groups[i].id.split("_")[1];
                        adjustValue.push(value);
                        adjustTexts.push(groups[i]);
                    }
                }
            }

            this.addTextAlign(adjustTexts, adjustValue);
    }

    /**
     * 
     * @param {Array<SVGGElement>} nodes 
     */
    addTextAlign(nodes, paragraphWidth) {
        for(let i = 0; i < nodes.length; i++) {
            const groups = nodes[i].getElementsByTagName("g");
            for(let j = 0; j < groups.length; j++) {
                const text = groups[j].getElementsByTagName("text");
                for(let k = 0; k < text.length; k++) {
                    this.modifyTextAlign(text.item(k).children, paragraphWidth[i]);
                }
            }
        }
    }
    /**
     * 調整每一句文字的間距，除了最後一行
     * @param {HTMLCollectionOf<SVGTSpanElement>} nodes 
     * @param {string} value 每個段落的寬度
     */
    modifyTextAlign(nodes, paragraphWidth) {
        for(let i = 0; i < nodes.length - 1; i++) {
            nodes[i].setAttribute("textLength", paragraphWidth);
        }
    }
}